import { Routes, Route, HashRouter } from 'react-router-dom';
import Home from './pages/home';
import Withholding from './pages/withholding';
import BaeminMenuCopy from './pages/baeminMenuCopy';
import ESignScreen from './pages/eSign';
import { ESignProvider } from './pages/eSignApplication/eSignApplicationContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ESignSignPage from 'pages/eSignApplication/ESignSignPage';
import ESignAgreementPage from 'pages/eSignApplication/ESignAgreementPage';
import ESignContractPage from 'pages/eSignApplication/ESignContractPage';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <ESignProvider>
          <Routes>
            <Route path={ROUTES.home} element={<Home />} />
            <Route path={ROUTES.withholding} element={<Withholding />} />
            <Route path={ROUTES.baeminMenuCopy} element={<BaeminMenuCopy />} />

            <Route path={ROUTES.eSign} element={<ESignScreen />} />
            <Route path={ROUTES.eSignContract} element={<ESignContractPage />} />
            <Route path={ROUTES.eSignAgreement} element={<ESignAgreementPage />} />
            <Route path={ROUTES.eSignSign} element={<ESignSignPage />} />
          </Routes>
        </ESignProvider>
      </HashRouter>
    </QueryClientProvider>
  );
}

export const ROUTES = {
  home: '/',
  withholding: '/withholding',
  baeminMenuCopy: '/baeminMenuCopy',

  eSign: '/e-sign',
  eSignContract: '/e-sign/contract',
  eSignAgreement: '/e-sign/agreement',
  eSignSign: '/e-sign/sign',
};

export default App;
